<script setup>
import { LEARN_MORE_METRIC_NAME } from '@/services/metrics'
import { generateUrlWithUtmParams } from '@/services/marketing'
import { logMetric } from '@/API/metrics'
import { useRoute } from 'vue-router'
import LaunchIcon from '@/components/icons/LaunchIcon.vue'

const { programLink, metaSalesforceId } = defineProps({
  programLink: {
    type: String,
    required: true,
  },
  metaSalesforceId: {
    type: String,
    required: false,
  },
})

const route = useRoute()

const handleOnClick = () => {
  const utmParams = {}
  if (metaSalesforceId) {
    utmParams.sid = metaSalesforceId
  }

  window.open(generateUrlWithUtmParams(programLink, utmParams), '_blank')

  const tags = {
    cta: 'About',
    salesforce_id: metaSalesforceId || '',
    source_path: route.path,
  }

  logMetric(LEARN_MORE_METRIC_NAME, tags).catch((err) => {
    throw new Error(`Failed to log metric with error: ${err}`)
  })
}
</script>

<template>
  <v-btn
    @click="handleOnClick"
    variant="text"
    aria-label="Learn about The Global Career Accelerator"
    class="about-cta__btn v-btn__light"
  >
    <span>About</span>
    <LaunchIcon color="#333759" class="about-cta__btn-icon" />
  </v-btn>
</template>

<style scoped>
.about-cta__btn {
  height: 60px !important;

  font-size: 16px;
  font-style: normal;
  line-height: 22px; /* 122.222% */
  align-content: center;

  background: transparent !important;
}

.about-cta__btn-icon {
  margin-left: 8px;
}
</style>
